import { defineStore } from "pinia";
import { ref } from "vue";

import type { Toast } from "@/model/toast";
import { asReadonly } from "@/utils/vue";

export const useToastStore = defineStore("toast", () => {
  const toast = ref({ messageKey: "", duration: 0, closeable: false });

  function show(messageKey: string, options?: Partial<Toast>) {
    if (!localStorage.getItem(hideKey(messageKey))) {
      toast.value = { messageKey, duration: 5000, closeable: false, ...options };
      if (toast.value.duration > 0) {
        setTimeout(hide, toast.value.duration);
      }
    }
  }

  function hide(noShowAgain?: boolean) {
    if (noShowAgain && toast.value.messageKey) {
      localStorage.setItem(hideKey(toast.value.messageKey), "true");
    }
    toast.value.messageKey = "";
  }

  return { toast: asReadonly(toast), show, hide };
});

function hideKey(key: string) {
  return `hide-${key}`;
}
